/* eslint-disable array-callback-return */
import { Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC } from 'react';
import { useApplication } from 'src/context/ApplicationContext';
import { ART_DES_ANTRAGS } from 'src/lib/constants/constant';
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import {
	SummaryBeantragteFoerderquote,
	SummaryBeantragteFoerderung,
	SummaryDatumDerEinreichung,
	SummaryGeplanteProjektAusgabe,
	SummaryGeplanteProjektLaufzeit,
	SummaryNameDerOrganisation,
	SummaryOrganisationAntragberechtigtAls,
	SummaryOrganisationFoerderQuote,
	SummaryProjektTitel,
	SummaryTitel,
	SummaryVerbundpartnerDetails,
	SummaryVorzeitigerVorhabenBeantragt,
	SummaryVorzeitigerVorhabenLaufzeit,
} from 'src/pages/private/online-antrag/antrag-components/AbschlussSeiteSummary';
import AbschlussSeiteBox from '../../../../antrag-components/AbschlussSeiteBox';
import FormantragFinanzierungsTabelle from './FormantragFinanzierungsTabelle';
import FormantragKostenTabelle from './FormantragKostenTabelle';

const P = AntragSchema.attributes;

const AbschlussAntragLoewe: FC<{}> = () => {
	const { application } = useApplication();
	const isFormantrag = get(application, P.Allgemein_Art_Des_Antrags.path, '') === ART_DES_ANTRAGS.Formantrag;

	if (isFormantrag) {
		return (
			<>
				<Typography fontWeight={700} sx={{ mt: 3 }} variant='h6'>
					Projektausgaben/Finanzierungsplan
				</Typography>
				<AbschlussSeiteBox>
					<Typography fontWeight={600}>1. Ausgabenplan</Typography>
					<FormantragKostenTabelle />
					<Typography fontWeight={600} sx={{ mt: 3 }} variant='body1'>
						2. Finanzierungsplan
					</Typography>
					<FormantragFinanzierungsTabelle />
				</AbschlussSeiteBox>
			</>
		);
	}

	return (
		<>
			<SummaryTitel />

			<AbschlussSeiteBox>
				<SummaryDatumDerEinreichung />

				<SummaryProjektTitel />
				<SummaryGeplanteProjektLaufzeit />

				<SummaryNameDerOrganisation />
				<SummaryOrganisationAntragberechtigtAls />

				<SummaryOrganisationFoerderQuote />

				<SummaryVerbundpartnerDetails />

				<SummaryVorzeitigerVorhabenBeantragt />
				<SummaryVorzeitigerVorhabenLaufzeit />

				<SummaryGeplanteProjektAusgabe />
				<SummaryBeantragteFoerderung />
				<SummaryBeantragteFoerderquote />
			</AbschlussSeiteBox>
		</>
	);
};

export default AbschlussAntragLoewe;
